import React from 'react';

export default function Guest() {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <g clipPath="url(#clip0_860_33352)">
        <path
          d="M4.3999 11.6006V14.8006H0.399902V13.2006H1.1999C1.86264 13.2006 2.3999 12.6633 2.3999 12.0006V11.6006H4.3999Z"
          fill="#ABCAA9"
        />
        <path d="M3.19995 11.6006H4.39995V14.8006H3.19995V11.6006Z" fill="#85AC82" />
        <path
          d="M2.3999 11.6006V12.0006C2.3999 12.6633 1.86264 13.2006 1.1999 13.2006H0.399902V12.4006C0.40122 11.9593 0.758622 11.6019 1.1999 11.6006H2.3999Z"
          fill="#A9CADA"
        />
        <path d="M6 11.6006H18V14.8006H6V11.6006Z" fill="#ABCAA9" />
        <path d="M16.8 11.6006H18V14.8006H16.8V11.6006Z" fill="#85AC82" />
        <path
          d="M23.6001 13.2006V14.8006H19.6001V11.6006H21.6001V12.0006C21.6001 12.6633 22.1374 13.2006 22.8001 13.2006H23.6001Z"
          fill="#ABCAA9"
        />
        <path d="M22.3999 13.2002V14.8002H23.5999V13.2002H22.7999H22.3999Z" fill="#85AC82" />
        <path
          d="M23.6001 12.4006V13.2006H22.8001C22.1374 13.2006 21.6001 12.6633 21.6001 12.0006V11.6006H22.8001C23.2414 11.6019 23.5988 11.9593 23.6001 12.4006Z"
          fill="#A9CADA"
        />
        <path
          d="M18.8 16.0006C19.2418 16.0006 19.6 15.4633 19.6 14.8006C19.6 14.1378 19.2418 13.6006 18.8 13.6006C18.3582 13.6006 18 14.1378 18 14.8006C18 15.4633 18.3582 16.0006 18.8 16.0006Z"
          fill="#FFE8C3"
        />
        <path
          d="M19.6 11.6006V14.8006C19.6 14.1366 19.24 13.6006 18.8 13.6006C18.36 13.6006 18 14.1366 18 14.8006V11.6006H19.6Z"
          fill="#FFE8C3"
        />
        <path
          d="M2.3999 20.8006V21.2006H1.1999C0.758622 21.1993 0.40122 20.8419 0.399902 20.4006V19.6006H1.1999C1.86264 19.6006 2.3999 20.1378 2.3999 20.8006Z"
          fill="#A9CADA"
        />
        <path
          d="M4.3999 14.8008V21.2008H2.3999V20.8008C2.3999 20.138 1.86264 19.6008 1.1999 19.6008H0.399902V14.8008H4.3999Z"
          fill="#EEC88B"
        />
        <path
          d="M5.9999 11.6006V14.8006C5.9999 14.1366 5.6399 13.6006 5.1999 13.6006C4.7599 13.6006 4.3999 14.1366 4.3999 14.8006V11.6006H5.9999Z"
          fill="#FFE8C3"
        />
        <path
          d="M5.9999 14.8008V21.2008H4.3999V14.8008C4.3999 15.4648 4.7599 16.0008 5.1999 16.0008C5.6399 16.0008 5.9999 15.4648 5.9999 14.8008Z"
          fill="#FFE8C3"
        />
        <path d="M6 14.8008H18V21.2008H6V14.8008Z" fill="#EEC88B" />
        <path
          d="M19.6 14.8008V21.2008H18V14.8008C18 15.4648 18.36 16.0008 18.8 16.0008C19.24 16.0008 19.6 15.4648 19.6 14.8008Z"
          fill="#FFE8C3"
        />
        <path
          d="M23.6001 14.8008V19.6008H22.8001C22.1374 19.6008 21.6001 20.138 21.6001 20.8008V21.2008H19.6001V14.8008H23.6001Z"
          fill="#EEC88B"
        />
        <path
          d="M22.3999 14.8008V19.6008H21.5999C20.9372 19.6008 20.3999 20.138 20.3999 20.8008V21.2008H21.5999V20.8008C21.5999 20.138 22.1372 19.6008 22.7999 19.6008H23.5999V14.8008H22.3999Z"
          fill="#EEC88B"
        />
        <path
          d="M23.6001 19.6006V20.4006C23.5988 20.8419 23.2414 21.1993 22.8001 21.2006H21.6001V20.8006C21.6001 20.1378 22.1374 19.6006 22.8001 19.6006H23.6001Z"
          fill="#A9CADA"
        />
        <path
          d="M8.4001 16.4004H8.8001C9.02101 16.4004 9.2001 16.5795 9.2001 16.8004V18.4004C9.2001 18.6213 9.02101 18.8004 8.8001 18.8004H8.4001C7.95827 18.8004 7.6001 18.4422 7.6001 18.0004V17.2004C7.6001 16.7586 7.95827 16.4004 8.4001 16.4004Z"
          fill="#FFE8C3"
        />
        <path
          d="M15.2 16.4004H15.6C16.0419 16.4004 16.4 16.7586 16.4 17.2004V18.0004C16.4 18.4422 16.0419 18.8004 15.6 18.8004H15.2C14.9791 18.8004 14.8 18.6213 14.8 18.4004V16.8004C14.8 16.5795 14.9791 16.4004 15.2 16.4004Z"
          fill="#FFE8C3"
        />
        <path d="M9.19995 16.8008H14.8V18.4008H9.19995V16.8008Z" fill="#A9CADA" />
        <path
          d="M22.3999 4.40078V6.00078H18.3999V2.80078H20.3999V3.20078C20.3999 3.86352 20.9372 4.40078 21.5999 4.40078H22.3999Z"
          fill="#ABCAA9"
        />
        <path d="M21.2 4.40039V6.00039H22.4V4.40039H21.6H21.2Z" fill="#85AC82" />
        <path d="M7.19995 2.80078H16.8V6.00078H7.19995V2.80078Z" fill="#ABCAA9" />
        <path d="M15.6001 2.80078H16.8001V6.00078H15.6001V2.80078Z" fill="#85AC82" />
        <path
          d="M5.6001 2.80078V6.00078H1.6001V4.40078H2.4001C3.06284 4.40078 3.6001 3.86352 3.6001 3.20078V2.80078H5.6001Z"
          fill="#ABCAA9"
        />
        <path d="M4.3999 2.80078H5.5999V6.00078H4.3999V2.80078Z" fill="#85AC82" />
        <path
          d="M22.3999 3.60078V4.40078H21.5999C20.9372 4.40078 20.3999 3.86352 20.3999 3.20078V2.80078H21.5999C22.0412 2.8021 22.3986 3.1595 22.3999 3.60078Z"
          fill="#A9CADA"
        />
        <path
          d="M3.6001 2.80078V3.20078C3.6001 3.86352 3.06284 4.40078 2.4001 4.40078H1.6001V3.60078C1.60142 3.1595 1.95882 2.8021 2.4001 2.80078H3.6001Z"
          fill="#A9CADA"
        />
        <path
          d="M6.39985 7.20078C6.84168 7.20078 7.19985 6.66352 7.19985 6.00078C7.19985 5.33804 6.84168 4.80078 6.39985 4.80078C5.95803 4.80078 5.59985 5.33804 5.59985 6.00078C5.59985 6.66352 5.95803 7.20078 6.39985 7.20078Z"
          fill="#FFE8C3"
        />
        <path
          d="M7.19985 2.80078V6.00078C7.19985 5.33678 6.83985 4.80078 6.39985 4.80078C5.95985 4.80078 5.59985 5.33678 5.59985 6.00078V2.80078H7.19985Z"
          fill="#FFE8C3"
        />
        <path d="M7.19995 6H16.8V11.6H7.19995V6Z" fill="#EEC88B" />
        <path
          d="M18.4001 6V11.6H16.8V6C16.8 6.664 17.16 7.2 17.6 7.2C18.0401 7.2 18.4001 6.664 18.4001 6Z"
          fill="#FFE8C3"
        />
        <path
          d="M17.6 7.20078C18.0419 7.20078 18.4001 6.66352 18.4001 6.00078C18.4001 5.33804 18.0419 4.80078 17.6 4.80078C17.1582 4.80078 16.8 5.33804 16.8 6.00078C16.8 6.66352 17.1582 7.20078 17.6 7.20078Z"
          fill="#FFE8C3"
        />
        <path
          d="M18.4001 2.80078V6.00078C18.4001 5.33678 18.0401 4.80078 17.6 4.80078C17.16 4.80078 16.8 5.33678 16.8 6.00078V2.80078H18.4001Z"
          fill="#FFE8C3"
        />
        <path
          d="M5.1999 16.0006C5.64173 16.0006 5.9999 15.4633 5.9999 14.8006C5.9999 14.1378 5.64173 13.6006 5.1999 13.6006C4.75807 13.6006 4.3999 14.1378 4.3999 14.8006C4.3999 15.4633 4.75807 16.0006 5.1999 16.0006Z"
          fill="#FFE8C3"
        />
        <path
          d="M7.19985 6V11.6H5.59985V6C5.59985 6.664 5.95985 7.2 6.39985 7.2C6.83985 7.2 7.19985 6.664 7.19985 6Z"
          fill="#FFE8C3"
        />
        <path d="M5.6001 6V11.6H3.6001V11.2C3.6001 10.5373 3.06284 10 2.4001 10H1.6001V6H5.6001Z" fill="#EEC88B" />
        <path
          d="M3.6001 11.2V11.6H2.3761C1.94431 11.5856 1.60136 11.232 1.6001 10.8V10H2.4001C3.06284 10 3.6001 10.5373 3.6001 11.2Z"
          fill="#A9CADA"
        />
        <path
          d="M22.3999 10V10.8C22.3986 11.2413 22.0412 11.5987 21.5999 11.6H20.3999V11.2C20.3999 10.5373 20.9372 10 21.5999 10H22.3999Z"
          fill="#A9CADA"
        />
        <path
          d="M22.3999 6V10H21.5999C20.9372 10 20.3999 10.5373 20.3999 11.2V11.6H18.3999V6H22.3999Z"
          fill="#EEC88B"
        />
        <path
          d="M21.2 6V10H20.4C19.7372 10 19.2 10.5373 19.2 11.2V11.6H20.4V11.2C20.4 10.5373 20.9372 10 21.6 10H22.4V6H21.2Z"
          fill="#EEC88B"
        />
        <path
          d="M9.60005 7.60059H10C10.221 7.60059 10.4 7.77967 10.4 8.00059V9.60059C10.4 9.8215 10.221 10.0006 10 10.0006H9.60005C9.15822 10.0006 8.80005 9.64241 8.80005 9.20059V8.40059C8.80005 7.95876 9.15822 7.60059 9.60005 7.60059Z"
          fill="#FFE8C3"
        />
        <path
          d="M14.0001 7.60059H14.4001C14.8419 7.60059 15.2001 7.95876 15.2001 8.40059V9.20059C15.2001 9.64241 14.8419 10.0006 14.4001 10.0006H14.0001C13.7792 10.0006 13.6001 9.8215 13.6001 9.60059V8.00059C13.6001 7.77967 13.7792 7.60059 14.0001 7.60059Z"
          fill="#FFE8C3"
        />
        <path d="M10.3999 8H13.5999V9.6H10.3999V8Z" fill="#A9CADA" />
        <path
          d="M22.8 11.2004H22.7264C22.7738 11.0723 22.7987 10.937 22.8 10.8004V3.60039C22.8 2.93765 22.2627 2.40039 21.6 2.40039H2.4C1.73726 2.40039 1.2 2.93765 1.2 3.60039V10.8004C1.20133 10.937 1.22623 11.0723 1.2736 11.2004H1.2C0.537258 11.2004 0 11.7376 0 12.4004V20.4004C0 21.0631 0.537258 21.6004 1.2 21.6004H22.8C23.4627 21.6004 24 21.0631 24 20.4004V12.4004C24 11.7376 23.4627 11.2004 22.8 11.2004ZM21.2 20.8004H20V15.2004H23.2V19.2004H22.8C21.9163 19.2004 21.2 19.9167 21.2 20.8004ZM0.8 13.6004H1.2C2.08366 13.6004 2.8 12.884 2.8 12.0004H4V14.4004H0.8V13.6004ZM2.4 9.60039H2V6.40039H5.2V11.2004H4C4 10.3167 3.28366 9.60039 2.4 9.60039ZM4 3.20039H5.2V5.60039H2V4.80039H2.4C3.28366 4.80039 4 4.08405 4 3.20039ZM22 9.60039H21.6C20.7163 9.60039 20 10.3167 20 11.2004H18.8V6.40039H22V9.60039ZM22.8 13.6004H23.2V14.4004H20V12.0004H21.2C21.2 12.884 21.9163 13.6004 22.8 13.6004ZM4.8 12.0004H5.6V13.2952C5.34832 13.1688 5.05169 13.1688 4.8 13.2952V12.0004ZM6 7.50559C6.25169 7.632 6.54832 7.632 6.8 7.50559V11.2004H6V7.50559ZM18 11.2004H17.2V7.50559C17.4517 7.632 17.7483 7.632 18 7.50559V11.2004ZM16.4 11.2004H7.6V6.40039H16.4V11.2004ZM6.4 12.0004H17.6V14.4004H6.4V12.0004ZM18.4 12.0004H19.2V13.2952C18.9483 13.1688 18.6517 13.1688 18.4 13.2952V12.0004ZM17.6 6.80039C17.4368 6.80039 17.2 6.48879 17.2 6.00039C17.2 5.51199 17.4368 5.20039 17.6 5.20039C17.7632 5.20039 18 5.51199 18 6.00039C18 6.48879 17.7632 6.80039 17.6 6.80039ZM16.4 5.60039H7.6V3.20039H16.4V5.60039ZM6.4 6.80039C6.2368 6.80039 6 6.48879 6 6.00039C6 5.51199 6.2368 5.20039 6.4 5.20039C6.5632 5.20039 6.8 5.51199 6.8 6.00039C6.8 6.48879 6.5632 6.80039 6.4 6.80039ZM5.2 14.0004C5.3632 14.0004 5.6 14.312 5.6 14.8004C5.6 15.2888 5.3632 15.6004 5.2 15.6004C5.0368 15.6004 4.8 15.2888 4.8 14.8004C4.8 14.312 5.0368 14.0004 5.2 14.0004ZM6.4 15.2004H17.6V20.8004H6.4V15.2004ZM18.8 14.0004C18.9632 14.0004 19.2 14.312 19.2 14.8004C19.2 15.2888 18.9632 15.6004 18.8 15.6004C18.6368 15.6004 18.4 15.2888 18.4 14.8004C18.4 14.312 18.6368 14.0004 18.8 14.0004ZM23.2 12.4004V12.8004H22.8C22.3582 12.8004 22 12.4422 22 12.0004H22.8C23.0209 12.0004 23.2 12.1795 23.2 12.4004ZM20.8 11.2004C20.8 10.7586 21.1582 10.4004 21.6 10.4004H22V10.8004C22 11.0213 21.8209 11.2004 21.6 11.2004H20.8ZM22 3.60039V4.00039H21.6C21.1582 4.00039 20.8 3.64222 20.8 3.20039H21.6C21.8209 3.20039 22 3.37948 22 3.60039ZM21.6 4.80039H22V5.60039H18.8V3.20039H20C20 4.08405 20.7163 4.80039 21.6 4.80039ZM18 3.20039V4.49519C17.7483 4.36878 17.4517 4.36878 17.2 4.49519V3.20039H18ZM6.8 3.20039V4.49519C6.54832 4.36878 6.25169 4.36878 6 4.49519V3.20039H6.8ZM2.4 3.20039H3.2C3.2 3.64222 2.84183 4.00039 2.4 4.00039H2V3.60039C2 3.37948 2.17909 3.20039 2.4 3.20039ZM2 10.8004V10.4004H2.4C2.84183 10.4004 3.2 10.7586 3.2 11.2004H2.4C2.17909 11.2004 2 11.0213 2 10.8004ZM1.2 12.0004H2C2 12.4422 1.64183 12.8004 1.2 12.8004H0.8V12.4004C0.8 12.1795 0.979086 12.0004 1.2 12.0004ZM0.8 20.4004V20.0004H1.2C1.64183 20.0004 2 20.3586 2 20.8004H1.2C0.979086 20.8004 0.8 20.6213 0.8 20.4004ZM1.2 19.2004H0.8V15.2004H4V20.8004H2.8C2.8 19.9167 2.08366 19.2004 1.2 19.2004ZM4.8 20.8004V16.3056C5.05169 16.432 5.34832 16.432 5.6 16.3056V20.8004H4.8ZM18.4 20.8004V16.3056C18.6517 16.432 18.9483 16.432 19.2 16.3056V20.8004H18.4ZM22.8 20.8004H22C22 20.3586 22.3582 20.0004 22.8 20.0004H23.2V20.4004C23.2 20.6213 23.0209 20.8004 22.8 20.8004Z"
          fill="#373737"
        />
        <path
          d="M15.6 16H15.2C14.9154 16.0009 14.6529 16.1533 14.5112 16.4H9.48875C9.34699 16.1533 9.08448 16.0009 8.79995 16H8.39995C7.73721 16 7.19995 16.5373 7.19995 17.2V18C7.19995 18.6627 7.73721 19.2 8.39995 19.2H8.79995C9.08448 19.1991 9.34699 19.0467 9.48875 18.8H14.5112C14.6529 19.0467 14.9154 19.1991 15.2 19.2H15.6C16.2627 19.2 16.8 18.6627 16.8 18V17.2C16.8 16.5373 16.2627 16 15.6 16ZM8.39995 18.4C8.17904 18.4 7.99995 18.2209 7.99995 18V17.2C7.99995 16.9791 8.17904 16.8 8.39995 16.8H8.79995V18.4H8.39995ZM9.59995 17.2H14.4V18H9.59995V17.2ZM16 18C16 18.2209 15.8209 18.4 15.6 18.4H15.2V16.8H15.6C15.8209 16.8 16 16.9791 16 17.2V18Z"
          fill="#373737"
        />
        <path
          d="M9.5999 10.4002H9.9999C10.2844 10.3993 10.5469 10.2469 10.6887 10.0002H13.3111C13.4529 10.2469 13.7154 10.3993 13.9999 10.4002H14.3999C15.0626 10.4002 15.5999 9.86294 15.5999 9.2002V8.4002C15.5999 7.73745 15.0626 7.2002 14.3999 7.2002H13.9999C13.7154 7.20105 13.4529 7.35349 13.3111 7.6002H10.6887C10.5469 7.35349 10.2844 7.20105 9.9999 7.2002H9.5999C8.93716 7.2002 8.3999 7.73745 8.3999 8.4002V9.2002C8.3999 9.86294 8.93716 10.4002 9.5999 10.4002ZM14.3999 8.0002C14.6208 8.0002 14.7999 8.17928 14.7999 8.4002V9.2002C14.7999 9.42111 14.6208 9.6002 14.3999 9.6002H13.9999V8.0002H14.3999ZM13.1999 9.2002H10.7999V8.4002H13.1999V9.2002ZM9.1999 8.4002C9.1999 8.17928 9.37899 8.0002 9.5999 8.0002H9.9999V9.6002H9.5999C9.37899 9.6002 9.1999 9.42111 9.1999 9.2002V8.4002Z"
          fill="#373737"
        />
      </g>
      <defs>
        <clipPath id="clip0_860_33352">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
